export function removeUUIDFromEmail(email: string): string {
  const [name, domain] = email.split('@');

  // Remove UUID pattern (xxxxxxxx-xxxx-xxxx-xxxx-xxxxxxxxxxxx) from the name part
  const cleanedName = name.replace(
    /[._+-]?[\da-f]{8}-[\da-f]{4}-[\da-f]{4}-[\da-f]{4}-[\da-f]{12}/i,
    '',
  );

  return `${cleanedName}@${domain}`;
}
